// containerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  containerProps: {
    background: '#FFFFFF',
    height: 10,
    radius: 8,
    fullWidth: false,
    spacing: {
      top: 5,
      right: 0,
      bottom: 5,
      left: 0,
    },
    margin: {
      top: 5,
      right: 10,
      bottom: 5,
      left: 10,
    },
    isApplyPaddingOnAllSides: false,
    isApplyMarginOnAllSides: false,
    allSideSpacing: 5,
    allSideMargin: 10,
    opacity: 100,
    border: {
      color: null,
      width: 1,
    },
    dropShadowColor: null,
    isFirstContainer: true,
  },
};

const containerStyleCopySlice = createSlice({
  name: 'container',
  initialState,
  reducers: {
    updateContainerProps: (state, action) => {
      state.containerProps = action.payload;
    },
    resetContainerProps: (state) => {
      // Resetting the state to initial values
      state.containerProps = initialState.containerProps;
    },
  },
});

export const { updateContainerProps, resetContainerProps } = containerStyleCopySlice.actions;
export default containerStyleCopySlice.reducer;
